<header>
  <nav class="navbar navbar-expand-md navbar-dark navbar-light">
    <a class="navbar-brand" [routerLink]="['/home']">
      <img src="assets/favicon/favicon.ico" width="30" height="30" alt="" />
    </a>
    <button
      type="button"
      data-toggle="collapse"
      data-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
      class="navbar-toggler"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li *ngFor="let node of nodes" class="nav-item">
          <a
            routerLinkActive="active"
            [routerLink]="getPathModule(node)"
            class="nav-link"
          >
            {{ node.name }}
          </a>
        </li>
      </ul>
      <div class="row d-flex">
        <span class="d-flex ml-3 mr-3" *ngIf="userProfile">
          {{ userProfile.name }} {{ userProfile.surname }}
        </span>
        <mat-icon
          (click)="onClickLogout()"
          [style.cursor]="'pointer'"
          class="mr-3"
        >
          exit_to_app
        </mat-icon>
      </div>
    </div>
  </nav>
</header>
